<template>
    <table class="table table-hover">
        <thead>
        <tr>
            <th class="text-uppercase">{{ __('general.store') }}</th>
            <th class="text-uppercase">{{ __('general.street') }}</th>
            <th class="text-uppercase">{{ __('general.city') }}</th>
            <th class="text-uppercase text-center">{{ __('actions.deactivate') }}</th>
            <th class="text-uppercase text-right">{{ __('general.actions') }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="store in stores">
            <td>{{ store.attributes.name }}</td>
            <td>{{ store.attributes.address.street1 }}</td>
            <td>{{ store.attributes.address.city }}</td>
            <td>
                <div class="d-flex flex-row justify-content-center">
                    <label class="checkbox checkbox-danger gap-2">
                        <input type="checkbox" v-model="selectedStores[store.id]">
                        <span></span>
                        {{ __('actions.deactivate') }}
                    </label>
                </div>
            </td>
            <td class="text-right">
                <button v-if="hasStoreConfig" @click="editStoreConfig(store.id)"
                        class="btn btn-xs btn-secondary">
                    <i class="fas fa-pen"/>
                    {{ __('actions.edit_thing', {thing: __('general.settings')}) }}
                </button>
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    props: {
        integration: Object,
        value: Array,
        stores: {
            types: [Object, Array]
        }
    },

    data() {
        return {
            selectedStores: []
        }
    },

    mounted() {
        this.selectedStores = this.value
    },

    methods: {
        editStoreConfig(storeUuid) {
            if (this.integration.abilities.includes('HasStoreConfigs')) {
                this.$inertia.visit(this.$route('integration.store.config', [this.integration.code, storeUuid]));
            }
        },
    },

    computed: {
        hasStoreConfig() {
            return this.integration.abilities.includes('HasStoreConfigs')
            || this.integration.code === 'MFN'
            || this.integration.code === 'AMZN'
        }
    },

    watch: {
        selectedStores(newValue, oldValue) {
            this.$emit('input', newValue)
        }
    }
}
</script>
